import { css } from "styled-components";

//   _____ _________     ___      ______    _____ _    _ _____ _____  ______
//  / ____|__   __\ \   / / |    |  ____|  / ____| |  | |_   _|  __ \|  ____|
// | (___    | |   \ \_/ /| |    | |__    | |  __| |  | | | | | |  | | |__
//  \___ \   | |    \   / | |    |  __|   | | |_ | |  | | | | | |  | |  __|
//  ____) |  | |     | |  | |____| |____  | |__| | |__| |_| |_| |__| | |____
// |_____/   |_|     |_|  |______|______|  \_____|\____/|_____|_____/|______|
//

// DO NOT ADD/MODIFY STYLEGUIDE VARIABLES UNLESS/UNTIL IT'S SYNCED WITH DESIGNERS

/*-------------- MAIN COLORS -----------------*/
export const colorPrimary = "#1890FF";
export const colorPrimaryFade = "#D9EDFF";
export const colorSelect = "#E6F4FF";
export const colorHivery = "#4F4CF4";
export const colorHiveryFade = "#706EFF";
export const colorGreen = "#82CC1F";
export const colorGreenFade = "#E5FBCF";
export const colorGold = "#FFB107";
export const colorGoldFade = "#FDF3C7";
export const colorRed = "#F65D3E";
export const colorRedFade = "#FFE8E2";
export const colorSky = "#4FB9F5";
export const colorSkyFade = "#BCE7FF";
export const colorPeach = "#F98A5B";
export const colorPeachFade = "#F9D8CA";
export const colorTurquoise = "#13C2C2";
export const colorTurquoiseFade = "#B7ECEC";
export const colorPurple = "#722ED1";
export const colorPurpleFade = "#E6DCF5";
export const colorTooltip = "#2F3640";
export const colorNavDark = "#00141E";
export const colorDark = "#6E7074";
export const colorDefault = "#989A9E";
export const colorComponent = "#BEC0C4";
export const colorComponent2 = "#D8DADE";
export const colorComponent3 = "#E4E6EA";
export const colorBgLight = "#F2F2F4";
export const colorBgXtraLight = "#F7F7F9";
export const colorWhite = "#FFFFFF";
export const colorOption = "#004DBA";
export const colorPrimaryLight = "#4CA6ff";
// This is only here till styled-components is updated for hex rgba support
export const colorHiveryLightFade = "#EEEDFE";

/*-------------- FONT COLORS -----------------*/
export const colorFontDefault = "#333333";
export const colorFontOptional = colorDark;
export const colorFontSecondary = colorDefault;
export const colorFontInactive = colorComponent;
export const colorFontReversed = colorWhite;

/*-------------- SPACING -----------------*/
export const spacing2 = "2px";
export const spacing4 = "4px";
export const spacing5 = "5px";
export const spacing6 = "6px";
export const spacing8 = "8px";
export const spacing12 = "12px";
export const spacing10 = "10px";
export const spacing16 = "16px";
export const spacing20 = "20px";
export const spacing23 = "23px";
export const spacing24 = "24px";
export const spacing25 = "25px";
export const spacing28 = "28px";
export const spacing30 = "30px";
export const spacing32 = "32px";
export const spacing38 = "38px";
export const spacing40 = "40px";
export const spacing48 = "48px";
export const spacing52 = "52px";
export const spacing56 = "56px";
export const spacing60 = "60px";
export const spacing64 = "64px";
export const spacing120 = "120px";
export const spacing330 = "330px";

/*-------------- BORDERS -----------------*/
export const borderWidth1 = "1px";
export const borderRadius2 = "2px";
export const borderRadius4 = "4px";
export const borderRadius8 = "8px";
export const borderRadius10 = "10px";
export const borderRadius12 = "12px";
export const borderRadius16 = "16px";

/*-------------- FONT SIZES AND LINE HEIGHTS -----------------*/
export const font11 = { fontSize: "11px", lineHeight: "16px" };
export const font12 = { fontSize: "12px", lineHeight: "16px" };
export const font14 = { fontSize: "14px", lineHeight: "20px" };
export const font16 = { fontSize: "16px", lineHeight: "20px" };
export const font20 = { fontSize: "20px", lineHeight: "24px" };
export const font24 = { fontSize: "24px", lineHeight: "28px" };
export const font28 = { fontSize: "28px", lineHeight: "32px" };

/*-------------- FONT -----------------*/
export const fontDefault = "Lato, openSans";

/*-------------- FONT WEIGHTS -----------------*/
export const fontWeight400 = "400";
export const fontWeight600 = "600";
export const fontWeight700 = "700";

//           _____  _____   __      __     _____  _____          ____  _      ______  _____
//     /\   |  __ \|  __ \  \ \    / /\   |  __ \|_   _|   /\   |  _ \| |    |  ____|/ ____|
//    /  \  | |__) | |__) |  \ \  / /  \  | |__) | | |    /  \  | |_) | |    | |__  | (___
//   / /\ \ |  ___/|  ___/    \ \/ / /\ \ |  _  /  | |   / /\ \ |  _ <| |    |  __|  \___ \
//  / ____ \| |    | |         \  / ____ \| | \ \ _| |_ / ____ \| |_) | |____| |____ ____) |
// /_/    \_\_|    |_|          \/_/    \_\_|  \_\_____/_/    \_\____/|______|______|_____/

// VARIABLES USED BY THE APP COMPONENTS BUT NOT RELATED TO THE STYLEGUIDE

/*-------------- SPACING -----------------*/
export const spacingNavWidth = `56px`;
export const spacingHeaderHeight = "128px";
export const spacingTabBarHeight = "40px";
export const spacingIconHeight = "72px";
export const spacingDropdownMenuItemHeight = "32px";
export const spacingDropdownMenuMaxHeight = "224px";
export const spacingAggregationWidth = "300px";

/*-------------- SCREENS -----------------*/
export const screenLarge = "900px";
export const screenSmall = "280px";

/*-------------- Z-INDEX -----------------*/
export const hiddenZIndex = "-1";
export const defaultZIndex = "0";
export const headerZIndex = "1";
export const menuZIndex = "2";
export const productShelfZIndex = "100";
export const productZIndex = "200";
// Tooltip 1003 to sit above Modal
export const tooltipZIndex = "1003";
export const productHoverZIndex = "300";
export const legacyProductFullScreenZIndex = "900";
export const topZIndex = "999";
/* 1001 is for having higher value than the legacy page 1000 */
export const MaskZIndex = "1001";
/* 1002 is for having higher value than the legacy page header 1000 */
export const ModalZIndex = "1002";

/* Comparison mode draggable element absolutely has to be on top of everything else */
export const comparisonModeDraggableZIndex = "9999";

/*--------------- FOOTER -----------------*/
export const footerHeight = "120px";
export const footerTopPadding = "32px";
export const footerPadding = `${footerTopPadding} 40px 32px`;

/*-------------- MASK COLORS -----------------*/
export const colorMaskBlackMedium = "rgba(110, 112, 116, 0.05)";
export const colorMaskLightBlue = "rgba(230, 247, 255, .2)";
export const colorMaskBlackDark = "rgba(0, 0, 0, 0.4)";
export const colorMaskPrimary = "rgba(24, 144, 255, .25)";

/*-------------- MODALS -----------------*/
export const confirmModal = "420px";
export const narrowModal = "488px";
export const narrowInput = "340px";
export const wideModal = "600px";
export const wideInput = "396px";
export const extraWideModal = "872px";

/*-------------- SIDEBAR -----------------*/
export const sidebarWidth = "400px";
export const uploadSidebarWidth = "240px";

/*-------------- TITLES -----------------*/
export const inlineTitle = css`
  ${font16};
  font-weight: 700;
`;
export const inlineSubTitle = css`
  ${font14};
  font-weight: 700;
`;

/*-------------- ANIMATIOMS -----------------*/
export const animationEasing = "0.3s ease-in-out";
export const antDAnimation = "0.3s cubic-bezier(0.645, 0.045, 0.355, 1)";

/*-------------- Box Shadows -----------------*/
export const boxShadow = `1px 4px 8px 2px rgba(110, 112, 115, 0.15)`;
export const cardBoxShadow = "0 8px 16px 0 rgba(0, 0, 0, 0.08)";

/*-------------- Inputs -----------------*/
export const inputHeight = "20px";

/*-------------- Accessibility -----------------*/
export const mouseHoverState = "&:hover,&:active,&:focus";
export const keyboardFocusState = "&:active,&:focus";

export const buttonHeight = "24px";
export const buttonWidth = "24px";

/*-------------- Responsive ScreenSizes -----------------*/

export const smallScreenOnly = "@media screen and (max-width: 1500px)";
export const largeScreenOnly = "@media screen and (min-width: 1501px)";
